<template>
  <span class="text">{{ data }}</span>
  <span v-if="showBtn" class="btn" @click="handleClick" data-testid="components-longtext-click">{{ btnText }}</span>
</template>

<script>
import { useI18n } from 'vue-i18n';
import { defineComponent, ref, computed, watch } from 'vue';

export default defineComponent({
  props: {
    text: {
      type: String,
      default: ''
    },
    limit: {
      type: Number,
      default: 100
    }
  },
  setup(props) {
    const { t } = useI18n();
    const btnText = ref(
      t('components.LongText.00f48aec676e879011137978ac13e3a5')
    );
    const data = ref('');
    const showBtn = computed(() => {
      return props.text.length > props.limit;
    });
    const handleClick = () => {
      btnText.value =
        btnText.value ===
        t('components.LongText.00f48aec676e879011137978ac13e3a5')
          ? t('components.LongText.a73d5a31369e70404f9151f59c37364e')
          : t('components.LongText.00f48aec676e879011137978ac13e3a5');
      if (
        btnText.value ===
        t('components.LongText.a73d5a31369e70404f9151f59c37364e')
      ) {
        data.value = props.text;
      } else {
        data.value = `${props.text.slice(0, props.limit)}...`;
      }
    };
    watch(
      () => props.text,
      () => {
        if (props.text.length > props.limit) {
          data.value = `${props.text.slice(0, props.limit)}...`;
        } else {
          data.value = props.text;
        }
      },
      {
        immediate: true
      }
    );
    return {
      btnText,
      handleClick,
      showBtn,
      data
    };
  }
});
</script>

<style scoped lang="less">
.btn {
  display: inline-block;
  color: var(--theme-color);
  cursor: pointer;
  margin-left: 4px;
}
.text {
  white-space: pre-line;
}
</style>
